import { Component } from '@angular/core';
import { InfoBannerComponent } from '../../../../shared/components/ui/info-banner/info-banner.component';

@Component({
  selector: 'app-parent-ai-verification-banner',
  standalone: true,
  imports: [InfoBannerComponent],
  templateUrl: './parent-ai-verification-banner.component.html',
  styleUrl: './parent-ai-verification-banner.component.scss',
})
export class ParentAiVerificationBannerComponent {}
